import { $FIXME } from "../types/app.types";
import {
  getConfigFilePath,
  saveJSONdataAsFile,
  showAlertInInDesign,
} from "./inDesignServices";

export const getURL = (type: string) => {
  return "";
};

export const getFromStorage = (key: string): any | null => {
  const item = localStorage.getItem(key);
  if (item) {
    try {
      return JSON.parse(item);
    } catch (error) {
      console.error("Error parsing JSON from localStorage", error);
      return null;
    }
  }
  return null;
};

export const saveOnStorage = async (key: string, val: $FIXME) => {
  localStorage.setItem(key, JSON.stringify(val == undefined ? null : val));
};
export const removeAllFromStorage = async () => {
  localStorage.clear();
};
// Setter Function
export const saveOnConfigFile = async (key: string, val: any): Promise<any> => {
  let configPath = await getConfigFilePath();
  if (configPath.includes("Error")) {
    showAlertInInDesign(configPath, "Error");
    return;
  }
  console.log("xxx", configPath);
  let result = await saveJSONdataAsFile(configPath as string, val);
  // console.log("result", result, val)
  if ((result as string).includes("Error")) {
    showAlertInInDesign(result as string, "Error");
    return;
  }
  saveOnStorage(key, val);
  await showAlertInInDesign("Config file saved succesfully", "Success");
  return result;
};

export const flattenObject = (obj, parentKey = "", result = {}) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof obj[key] === "object" && obj[key] !== null) {
        flattenObject(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
};

export const generateWhereClause = (filters) => {
  const queryParts = filters.reduce((acc, filter) => {
    if (filter.field && filter.operator && filter.value) {
      let value;

      // Convert the value based on the selected type
      if (filter.type === "number") {
        value = parseFloat(filter.value);
      } else if (filter.type === "date") {
        value = `'${new Date(filter.value).toISOString().split("T")[0]}'`; // format date as 'YYYY-MM-DD'
      } else {
        value = `'${filter.value.replace(/'/g, "''")}'`; // escape single quotes in strings
      }

      // Build the SQL query part
      let condition;
      switch (filter.operator) {
        case "equals":
          condition = `${filter.field} = ${value}`;
          break;
        case "not equal to":
          condition = `${filter.field} != ${value}`;
          break;
        case "less than":
          condition = `${filter.field} < ${value}`;
          break;
        case "greater than":
          condition = `${filter.field} > ${value}`;
          break;
        case "less or equal":
          condition = `${filter.field} <= ${value}`;
          break;
        case "greater or equal":
          condition = `${filter.field} >= ${value}`;
          break;
        default:
          condition = "";
      }

      if (condition) {
        acc.push(condition);
      }
    }
    return acc;
  }, []);
  // Join all conditions with AND for the final WHERE clause
  const whereClause =
    queryParts.length > 0 ? `WHERE ${queryParts.join(" AND ")}` : "";
  return whereClause;
};

export const convertDate = (dateTimeStr) => {
  // Split the string into date and time components
  let [datePart, timePart] = dateTimeStr.split("T");

  // Ensure we have a valid date part
  if (!datePart) {
    throw new Error("Invalid date format");
  }

  // Default time if time is not provided
  timePart = timePart || "00:00:00";

  // Split the timePart into time, milliseconds, and offset
  let [timeOnly, millisecondsOffset] = timePart.split(".");
  let milliseconds = "000";
  let offset = "+0000";

  if (millisecondsOffset) {
    // If milliseconds and offset are provided
    const [ms, os] = millisecondsOffset.split(/[+-]/);
    milliseconds = ms || "000";

    // Use offset if provided
    if (millisecondsOffset.includes("+") || millisecondsOffset.includes("-")) {
      offset = millisecondsOffset.slice(ms.length) || "+0000";
    }
  }

  // If no millisecondsOffset, check if there's just an offset at the end of the time
  if (
    !millisecondsOffset &&
    (timeOnly.includes("+") || timeOnly.includes("-"))
  ) {
    const splitTime = timeOnly.split(/[+-]/);
    timeOnly = splitTime[0];
    offset = timePart.slice(timeOnly.length) || "+0000";
  }

  // Ensure time has hours, minutes, and seconds
  let timeComponents = timeOnly.split(":");
  while (timeComponents.length < 3) {
    timeComponents.push("00"); // Add default values if hours, minutes, or seconds are missing
  }
  timeOnly = timeComponents.join(":");

  // Combine everything back into a full datetime string
  const result = `${datePart}T${timeOnly}.${milliseconds}${offset}`;
  return result;
};

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const openLinkInBrowser = (url: string) => {
  if (window.cep) {
    const csi = new CSInterface();
    csi.openURLInDefaultBrowser(url);
  } else {
    window.location.href = url;
  }
};
